import { Status, StatusModel } from '../../general';

export interface HistoryModel {
  status: StatusModel;
  activityTime: string;
  message: string;
}
